module.exports = __webpack_public_path__ + "media/photo/AdobeStock_292947691-f58fe44b.jpg";